import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  patientsCefxConcluidos: <any>[],
};

export const PatientCefxConcluidosSlice = createSlice({
  name: "patientsCefxConcluidos",
  initialState,
  reducers: {
    setpatientCefxConcluidos: (state, action: PayloadAction<any>) => {
      state.patientsCefxConcluidos = action.payload;
    },
    addPatientCefxConcluidos: (state, action: PayloadAction<any[]>) => {
      const existingIds = new Set(state.patientsCefxConcluidos.map((p) => p.id));
      const newPatients = action.payload.filter((newPatient) => !existingIds.has(newPatient.id));
      state.patientsCefxConcluidos = [...state.patientsCefxConcluidos, ...newPatients];
    },
    clearPatientCefxConcluidos: (state) => {
      state.patientsCefxConcluidos = [];
    },
  },
});


export const { setpatientCefxConcluidos, addPatientCefxConcluidos, clearPatientCefxConcluidos } = PatientCefxConcluidosSlice.actions;

export const selectPatientCefxConcluidos = (state: any) => state.patientsCefxConcluidos || [];

export default PatientCefxConcluidosSlice.reducer;
